// src/components/axiosInstance.js

import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

console.log("Current environment:", process.env.NODE_ENV);
console.log("API_URL", API_URL);

const axiosInstance = axios.create({
  baseURL: `${API_URL}`, // Replace with your actual API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle unauthorized errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check for authentication errors
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.error('Authentication error detected in axios interceptor:', error.response.status);
      
      // Clear token and other auth data
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      localStorage.removeItem('employeeName');
      localStorage.removeItem('employeeId');
      localStorage.removeItem('userStore');
      
      // Set a session expired flag so we can show a message on login page
      localStorage.setItem('sessionExpired', 'true');
      
      // Check if we're already on the login page to avoid redirect loops
      if (!window.location.pathname.includes('/login')) {
        console.log('Redirecting to login page due to expired session');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;